import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  ApiRef,
  BackstageIdentityApi,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  identityApiRef,
  oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import { fetchApiRef } from '@backstage/core-plugin-api';
import {
  KubernetesBackendClient,
  kubernetesApiRef,
  kubernetesAuthProvidersApiRef,
  KubernetesAuthProviders,
} from '@backstage/plugin-kubernetes';
import { packagesApiRef, PackagesApiClient } from './api';

export const localOidcAuthApiRef: ApiRef<
  OAuthApi &
  OpenIdConnectApi &
  ProfileInfoApi &
  BackstageIdentityApi &
  SessionApi
> = createApiRef({
  id: 'oidc',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory(
    {
      api: localOidcAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'oidc',
            title: 'OIDC',
            icon: () => null,
          },
          environment: configApi.getOptionalString('app.environment')
        })
  }),
  createApiFactory({
    api: packagesApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) => new PackagesApiClient({ discoveryApi, identityApi }),
  }),
  createApiFactory({
    api: kubernetesAuthProvidersApiRef,
    deps: {},
    factory: () => new KubernetesAuthProviders({} as any),
  }),
  createApiFactory({
    api: kubernetesApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      kubernetesAuthProvidersApi: kubernetesAuthProvidersApiRef,
    },
    factory: ({ discoveryApi, fetchApi, kubernetesAuthProvidersApi }) =>
      new KubernetesBackendClient({ discoveryApi, fetchApi, kubernetesAuthProvidersApi }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
